<template>
  <div class="inventory-next_page">
    <div class="admin_main">
      <div class="admin_container">
        <div class="inventory-next_main">
          <div class="d-flex mb-4 align-center">
            <inventory-item-filter
              :filter.sync="inventoryConfiguration.filter"
              @change="getInventoryByFilter"
            />
            <back-btn class="ml-3" />
          </div>
          <div class="table_inventory_next_ft">
            <div class="inventory_next_table">
              <table-with-filter
                :headers="headers"
                :items="items"
                :is-filterable="false"
              >
                <template #filter.product>
                  <vue-select
                    clearable
                    infinite
                    @input="getInventoryByFilter"
                    :getItemPromise="
                      ({ text, page }) =>
                        $store.dispatch('getProducts', {
                          name: text,
                          page,
                          limit: 15,
                        })
                    "
                    @next-page-resolved="
                      (data) => setProduct([products, ...data])
                    "
                    @item-resolved="setProduct"
                    v-model="inventoryConfiguration.filter.product_id"
                    :items="products"
                  >
                    <template #option="{ item }">
                      <v-list-item-title>
                        <p class="ma-0">{{ item.name }}</p>
                        <span class="v-messages" v-if="item.attrs">{{
                          item.attrs.join(" && ")
                        }}</span>
                      </v-list-item-title>
                    </template>
                  </vue-select>
                </template>
                <template #item.state="{ item }">
                  <v-sheet
                    :color="item.valid ? 'success' : 'error'"
                    style="display: inline-block"
                    class="pa-1 rounded"
                    dark
                    >{{ item.valid ? $t("inventoried") : $t("writeOffed") }}
                  </v-sheet>
                </template>
              </table-with-filter>
            </div>
            <vue-pagination
              class="mt-3"
              :length="inventoryConfiguration.pagination.lastPage"
              @input="changePage"
              v-if="inventoryConfiguration.pagination.lastPage > 1"
              v-model="inventoryConfiguration.pagination.page"
            ></vue-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InventoryItemFilter from "@/components/inventory/InventoryItemFilter";
import { makerPagination, trueSet } from "@/utils/pureFunctions";
import { dateParse } from "@/utils/pureFunctions";
import BackBtn from "@/components/ui/BackBtn";
import TableWithFilter from "@/components/ui/table/TableWithFilter";
import VueSelect from "@/components/ui/vue-select/VueSelect";
import VuePagination from "@/components/ui/vue-pagination/VuePagination";

export default {
  name: "inventory-item",
  props: ["id"],
  data() {
    return {
      items: [],
      products: [],
      productTypes: [],
      productGroups: [],
      inventoryConfiguration: {
        pagination: {
          page: 1,
          limit: 10,
          lastPage: 0,
        },
        filter: {},
        options: {
          sortBy: ["startedAt"],
          sortDesc: [false],
        },
      },
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("product"),
          value: "product",
        },
        { text: this.$t("categoryProduct"), value: "productTypeName" },
        { text: this.$t("type"), value: "productGroupName" },
        { text: this.$t("inventoryTime"), value: "inventoryTime" },
        { text: this.$t("count"), value: "count" },
        { text: this.$t("writeOffTime"), value: "writeOffTime" },
        { text: this.$t("state"), value: "state" },
      ];
    },
  },
  components: {
    VuePagination,
    VueSelect,
    TableWithFilter,
    BackBtn,
    InventoryItemFilter,
  },
  methods: {
    setProduct(products) {
      this.products = products;
    },
    async getInventoryByFilter() {
      if (this.inventoryConfiguration.pagination.page !== 1) {
        this.inventoryConfiguration.pagination.page = 1;
        await this.$router.replace({ query: { page: "1" } });
      }
      this.showLoading();
      await this.getInventory();
      this.clearLoading();
    },
    async changePage() {
      const { page: queryPage } = this.$route.query;
      const { page } = this.inventoryConfiguration.pagination;
      if (page.toString() !== queryPage) {
        try {
          this.showLoading();
          await this.$router.replace({ query: { page: `${page}` } });
          await this.getInventory();
          this.clearLoading();
        } catch (e) {
          this.setResponseError({ error: e });
        }
      }
    },
    async getInventory() {
      try {
        let params = { ...this.inventoryConfiguration.filter };
        const { page, limit } = this.inventoryConfiguration.pagination;
        const {
          sortBy: [sortBy],
          sortDesc: [sortDirection],
        } = this.inventoryConfiguration.options;
        params.page = page - 1;
        params.limit = limit;
        params.sortBy = sortBy;
        params.sortDirection = sortDirection;
        params.inventarizationId = this.id;
        const {
          data: { data, total },
        } = await this.$http.get(`inventarization-log/list`, {
          params,
        });
        this.inventoryConfiguration.pagination.lastPage = makerPagination({
          limit,
          total,
        }).lastPage;
        this.items = data.map(
          (
            item
            /**
             * @type Object
             * @property createdAt
             */
          ) => {
            item.valid = trueSet(item.valid);
            if (item.valid) {
              item.inventoryTime = dateParse(item.createdAt);
            } else {
              item.writeOffTime = dateParse(item.createdAt);
            }
            return item;
          }
        );
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
  },

  async mounted() {
    const { page } = this.$route.query;
    if (page) this.inventoryConfiguration.pagination.page = +page;
    this.showLoading();
    try {
      const { data: productGroups } = await this.$store.dispatch(
        "getProductGroups"
      );
      const { data: productTypes } = await this.$store.dispatch(
        "getProductTypes"
      );
      const { data: products } = await this.$store.dispatch("getProducts");
      this.productGroups = productGroups;
      this.productTypes = productTypes;
      this.products = products;
      await this.getInventory();
    } catch (e) {
      this.setResponseError({ error: e });
    } finally {
      this.clearLoading();
    }
  },
};
</script>
